import { IconButton } from '@shared/ui/IconButton';
import { CloseIcon } from '@shared/ui/icons';
import { styled } from '@shared/ui/styled';
import SupportButton from '_legacy/components/Shared/SupportButton';
import { ERROR_DURATION } from '@app/providers/NotificationsProvider';
import { enqueueSnackbar, closeSnackbar, SNACKBAR_VARIANTS } from 'redux_store';
import i18nInitialState from '@shared/config/translations';
import PropTypes from 'prop-types';

function showServerError(dispatch, message, options, duration) {
  return dispatch(
    enqueueSnackbar({
      message: message || <_UnknownError options={options} />,
      options: {
        variant: SNACKBAR_VARIANTS.error,
        autoHideDuration: duration || ERROR_DURATION,
        action: options
          ? (key) => (
              <>
                <SupportButton options={options} />
                <IconButton
                  onClick={() => {
                    dispatch(closeSnackbar(key));
                  }}
                  size="small"
                >
                  <CloseIcon />
                </IconButton>
              </>
            )
          : undefined,
      },
    }),
  );
}

export default showServerError;

const PREFIX = 'UnknownError';
const classes = {
  errorText: `${PREFIX}-errorText`,
};

const Root = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
  [`& .${classes.errorText}`]: {
    color: theme.palette.error.light,
    fontSize: 14,
    fontWeight: '400',
  },
}));

const _UnknownError = ({ options }) => {
  return (
    <Root>
      <div>{i18nInitialState.en.errors.unknownError}</div>
      {options && (
        <div className={classes.errorText}>{i18nInitialState.en.general.pleaseContactUs}</div>
      )}
    </Root>
  );
};

_UnknownError.propTypes = {
  options: PropTypes.shape({
    correlationUUID: PropTypes.string.isRequired,
    userUUID: PropTypes.string,
  }),
};

